import { indexTopics } from '@/mocks/animeData';

const colorMap: Record<string, { bg: string; text: string; iconBg: string }> = {
  primary: {
    bg: 'bg-primary-100/70',
    text: 'text-primary-700',
    iconBg: 'bg-primary-500',
  },
  accent: {
    bg: 'bg-accent-100/70',
    text: 'text-accent-700',
    iconBg: 'bg-accent-500',
  },
  secondary: {
    bg: 'bg-secondary-100/70',
    text: 'text-secondary-700',
    iconBg: 'bg-secondary-500',
  },
};

export default function IndexSection() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const el = document.querySelector('#carousel');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            热门专题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            七大主题分区，精准定位你的动漫口味，总有一个专题让你欲罢不能
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexTopics.map((topic) => {
            const c = colorMap[topic.color] || colorMap.primary;
            return (
              <a
                key={topic.title}
                href="#carousel"
                onClick={handleClick}
                className={`group block p-5 md:p-6 rounded-xl ${c.bg} hover:scale-[1.02] transition-all duration-300 cursor-pointer`}
              >
                <div className={`w-10 h-10 md:w-12 md:h-12 rounded-xl ${c.iconBg} flex items-center justify-center mb-4`}>
                  <i className={`${topic.icon} text-background-50 text-lg md:text-xl`}></i>
                </div>
                <h3 className={`font-heading text-base md:text-lg ${c.text} mb-2`}>
                  {topic.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {topic.desc}
                </p>
                <div className="flex items-center gap-1 mt-3 text-xs font-medium text-foreground-400 group-hover:text-foreground-600 transition-colors">
                  <span>探索专题</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}